import { AfterViewInit, ViewChild, Directive } from '@angular/core';
import { IonContent } from '@ionic/angular';

/**
 * Factorizes the retrieval of IonContent's scroll element.
 * The scroll element is retreived afterViewInit because of the Promise signature
 * (the use we make of the scroll element is very sensitive to timing,
 * and we don't want that code execution to postponed to the next tick)
 */
@Directive()
export abstract class AbstractComponentWithScrollContainer implements AfterViewInit {
  @ViewChild(IonContent) ionContent: IonContent;

  scrollContainer: HTMLElement;

  async ngAfterViewInit() {
    this.scrollContainer = await this.ionContent.getScrollElement();
    this.onScrollContainerReady();
  }

  /**
   * override if you need to do something as soon as the scrollContainer is available
   */
  protected onScrollContainerReady() {}
}
